export default function ($http) {
    return function (vehicleId, mileageId, mileageModel) {
        return $http.put(`api/vehicles/${vehicleId}/mileages/${mileageId}`, mileageModel);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/mileages/editMileage.js